import { Outlet } from "react-router";
import styles from "./MarketPage.module.css";
import PageAnimation from "../../Other/PageAnimation";
import { useContext, useEffect, useState } from "react";
import DataContext from "../../store/data-context";
import Header from "./comp/Header";
import ListActions from "./comp/ListActions/ListActions";
import ItemList from "./comp/ItemList";
import CartButton from "./comp/CartButton";
import CartContext from "../../store/cart-context";
import Cart from "./cart/Cart";

export default function MarketPage() {
  const dataCtx = useContext(DataContext);
  const cartCtx = useContext(CartContext);
  const [filters, setFilters] = useState([]);
  const [itemCount, setItemCount] = useState(0);
  const [cartIsOpen, setCartIsOpen] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {}, []);

  return (
    <PageAnimation>
      <header>
        <Header
          title={dataCtx.pageData.market.title}
          description={dataCtx.pageData.market.description}
          button={dataCtx.pageData.market.what_is_button}
        />
      </header>
      <main>
        <CartButton
          count={cartCtx.itemCounter}
          onOpen={() => {
            setCartIsOpen(true);
          }}
        />
        {cartIsOpen && (
          <Cart
            cartCtx={cartCtx}
            onClose={() => {
              setCartIsOpen(false);
            }}
            dataCtx={dataCtx}
          />
        )}

        <ListActions
          categories={dataCtx.categories}
          filter={dataCtx.pageData.market.filter_button}
          count={dataCtx.pageData.market.list_count}
          count_1={dataCtx.pageData.market.list_count_1}
          filters={filters}
          setFilters={setFilters}
          itemCount={itemCount}
        />
        <ItemList
          filters={filters}
          dataCtx={dataCtx}
          setItemCount={setItemCount}
        />
      </main>
    </PageAnimation>
  );
}
